import queueService from '@/services/Queue';
import socketClient from '@/services/SocketClient';
import { log, errorLog } from '@/utils/logger';
import router from '@/router';

export default {
  fetchQueue: async ({ commit }) => {
    try {
      const response = await queueService.fetch();
      commit('SET_QUEUE_LIST', response.data.object || []);
    } catch (err) {
      errorLog(err);
    }
  },

  connectSocket: async ({ commit }) => {
    try {
      await socketClient.connectPromise();
      socketClient.subscribe('/topic/fila-geral-atendimento', message => {
        log('removendo solicitação >>' + message.body);
        commit('REMOVE_QUEUE_ITEM', message.body);
      });
    } catch (err) {
      errorLog(err);
    }
  },

  setFilter: ({ commit }, filter) => commit('SET_FILTER', filter),

  toggleQueue: ({ commit }, open) => commit('TOGGLE_QUEUE', open),

  openMeeting: ({ commit, dispatch }, meetingId) => {
    commit('TOGGLE_ACTION_LOADING', true);

    router.push(`/treatments/${meetingId}`);

    dispatch('fetchQueue');

    commit('TOGGLE_ACTION_LOADING', false);
  },

  acceptQueue: async ({ commit, dispatch }, queueItemId) => {
    commit('TOGGLE_ACTION_LOADING', true);

    try {
      const response = await queueService.acceptQueue(queueItemId);
      const { id } = response.data.object;

      router.push(`/treatments/${id}`);

      dispatch('fetchQueue');
    } catch (err) {
      errorLog(err);
    }

    commit('TOGGLE_ACTION_LOADING', false);
  },

  acceptInterconsultation: async ({ commit }, queueItemId) => {
    commit('TOGGLE_ACTION_LOADING', true);

    try {
      await queueService.acceptInterconsultation(queueItemId);
    } catch (err) {
      errorLog(err);
    }

    commit('TOGGLE_ACTION_LOADING', false);
  },
};
